import { useState, useEffect } from 'react';
import { getFileType } from '../util/fileUtils';

export const useFilePreview = (attachment, isOpen) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    if (isOpen && attachment) {
      loadPreview();
    } else {
      resetState();
    }
  }, [isOpen, attachment]);

  const resetState = () => {
    setPreviewData(null);
    setError(null);
    setLoading(false);
  };

  const loadPreview = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const fileType = getFileType(attachment.name);
      const response = await fetchFileContent(attachment.url);
      
      setPreviewData({
        type: fileType,
        content: response,
        url: attachment.url
      });
    } catch (err) {
      setError(err.message || 'Failed to load preview');
    } finally {
      setLoading(false);
    }
  };

  const fetchFileContent = async (attachment) => {
    // Replace with your actual API call
    const response = await fetch(attachment.url);
    if (!response.ok) throw new Error('Failed to fetch file');
    
    const fileType = getFileType(attachment.name);
    
    switch (fileType) {
      case 'text':
      case 'code':
        return await response.text();
      case 'spreadsheet':
        if (attachment.name.toLowerCase().endsWith('.csv')) {
          return await response.text();
        }
        return await response.arrayBuffer();
      default:
        return response.url;
    }
  };

  return { loading, error, previewData, retry: loadPreview };
};
